(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["manual-product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ManualProductReviews extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.batchSize = Number(this.dataset.reviewBatch || 3);
      this.items = [...this.querySelectorAll('[data-review-item]')];
      this.button = this.querySelector('[data-review-load-more]');
      this.remaining = this.querySelector('[data-review-remaining]');
      this.dialog = this.querySelector('[data-review-dialog]');
      this.openButton = this.querySelector('[data-review-form-open]');
      this.button?.addEventListener('click', () => this.showNextBatch());
      this.openButton?.addEventListener('click', () => this.openReviewForm());
      this.querySelectorAll('[data-review-form-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeReviewForm());
      });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeReviewForm();
      });
      if (this.dialog?.hasAttribute('open')) {
        this.dialog.close();
        this.openReviewForm();
      }
      this.updateControls();
    }

    openReviewForm() {
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      this.dialog.querySelector('[data-review-form-status], input:not([type="hidden"])')?.focus();
    }

    closeReviewForm() {
      this.dialog?.close();
      this.openButton?.focus();
    }

    showNextBatch() {
      const nextItems = this.items.filter((item) => item.hidden).slice(0, this.batchSize);
      nextItems.forEach((item) => item.removeAttribute('hidden'));
      nextItems[0]?.setAttribute('tabindex', '-1');
      nextItems[0]?.focus({ preventScroll: true });
      this.updateControls();
    }

    updateControls() {
      if (!this.button) return;
      const hiddenCount = this.items.filter((item) => item.hidden).length;
      const container = this.button.closest('.manual-product-reviews__load-more');

      if (hiddenCount === 0) {
        container?.setAttribute('hidden', '');
        return;
      }

      if (this.remaining) {
        const label = hiddenCount === 1 ? this.dataset.remainingSingular : this.dataset.remainingPlural;
        this.remaining.textContent = label.replace('[count]', hiddenCount);
      }
    }
  }

  if (!customElements.get('manual-product-reviews')) {
    customElements.define('manual-product-reviews', ManualProductReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
